import axios from "axios";
import { DateTime } from "luxon";

class HolidayService {
    /**
     * UNUSED for now but it could come in handy later for gettting holidays that are hard to calculate
     * like Easter or if we made an editable google calendar just for this app.
     * This was pulling from a calendar that only returned calculatable holidays:
     *      (New Year's, Victoria Day, Canada Day, Labour Day, Truth&Reconciliation Day, Christmas)
     *    Or at least that's all that showed up at the front-end
     * ---------------------------------------------------------------------------------------
     * Retrieve public holidays for Canada and British Columbia from the Google Calendar API.
     * @returns An array of {@code DateTime} objects.
     */
    async getCalendarHolidays() {
        let apiUrl = `https://hockey.tbadigital.com/holidays.php`,
            //let apiUrl = `/holidays.json`,
            response = await axios(apiUrl),
            holidays = ((response.data || {}).items || []).filter((item) => {
                return (
                    item.status == "confirmed" &&
                    (item.description == "Public holiday" ||
                        /British Columbia/.test(item.description))
                );
            }),
            result = holidays
                .map((item) => {
                    return {
                        name: item.summary,
                        date: DateTime.fromSQL(item.start.date),
                        selected: true,
                    };
                })
                .sort((a, b) => {
                    return a.date > b.date ? 1 : -1;
                });

        return result;
    }
    getNoApiHolidays(startDate, endDate) {
        return [
            ...[getSingleDayHoliday("New Year's Day", dateOfYearFunction("01-01"))],
            ...[getSingleDayHoliday("Victoria Day", victoriaDay)],
            ...[getSingleDayHoliday("Canada Day", dateOfYearFunction("07-01"))],
            ...[getSingleDayHoliday("Labour Day", labourDay)],
            ...[getSingleDayHoliday("Truth and Reconciliation Day", dateOfYearFunction("09-30"))],
            ...[getSingleDayHoliday("Christmas Day", dateOfYearFunction("12-25"))],
            // above used to be from API -------------------------------------
            ...[getSingleDayHoliday("Super Bowl Sunday", superBowl)],
            ...[getSingleDayHoliday("Thanksgiving", thanksgiving)],
            ...[getSingleDayHoliday("Halloween", dateOfYearFunction("10-31"))],
            ...[getSingleDayHoliday("Remembrance Day", dateOfYearFunction("11-11"))],
            ...[getSingleDayHoliday("Family Day", familyDay)],
            ...[getSingleDayHoliday("Grapes and Hops", grapesAndHops)],
            // these are just placeholders now to remind the user to manually adjust -------------
            ...[getSingleDayHoliday("Spring break", dateOfYearFunction("03-16"))],
            ...[getSingleDayHoliday("Christmas Break", dateOfYearFunction("12-26"))],
            // below are not calculated because they vary ---------------------
            // ...getChristmasBreak(), // this could vary
            // ...getSpringBreak26VSB(),
        ].filter(exists);
        // --- internal functions -------------------------
        function exists(x) {
            return !!x;
        }
        function getSingleDayHoliday(name, dayFunction) {
            let date = inrangeDate(dayFunction);
            if (!date) return null;
            return { name, date, selected: true };
        }
        // function getChristmasBreak() {
        //     // done individually because there can be multiple intervals
        //     // e.g. 01-01 to 12-31 has [01-01] and [12-25 ... 12-31]
        //     return [
        //         inrangeDate(dateOfYearFunction("12-20")),
        //         inrangeDate(dateOfYearFunction("12-21")),
        //         inrangeDate(dateOfYearFunction("12-22")),
        //         inrangeDate(dateOfYearFunction("12-23")),
        //         inrangeDate(dateOfYearFunction("12-24")),
        //         inrangeDate(dateOfYearFunction("12-25")), // Christmas Day
        //         inrangeDate(dateOfYearFunction("12-26")),
        //         inrangeDate(dateOfYearFunction("12-27")),
        //         inrangeDate(dateOfYearFunction("12-28")),
        //         inrangeDate(dateOfYearFunction("12-29")),
        //         inrangeDate(dateOfYearFunction("12-30")),
        //         inrangeDate(dateOfYearFunction("12-31")),
        //         inrangeDate(dateOfYearFunction("01-01")), // New Year's Day
        //     ]
        //         .filter(exists)
        //         .map((date) => ({
        //             name: "Christmas Break",
        //             date: date,
        //             selected: true,
        //         }));
        // }
        // // Spring Break varies by year and district.
        // function getSpringBreak26VSB() {
        //     // https://media.vsb.bc.ca/media/Default/medialib/compact-calendar-2025-2026-final.85398268528.pdf
        //     return [
        //         inrangeDate(dateOfYearFunction("03-16")),
        //         inrangeDate(dateOfYearFunction("03-17")),
        //         inrangeDate(dateOfYearFunction("03-18")),
        //         inrangeDate(dateOfYearFunction("03-19")),
        //         inrangeDate(dateOfYearFunction("03-20")),
        //         inrangeDate(dateOfYearFunction("03-21")),
        //         inrangeDate(dateOfYearFunction("03-22")),
        //         inrangeDate(dateOfYearFunction("03-23")),
        //         inrangeDate(dateOfYearFunction("03-24")),
        //         inrangeDate(dateOfYearFunction("03-25")),
        //         inrangeDate(dateOfYearFunction("03-26")),
        //         inrangeDate(dateOfYearFunction("03-27")),
        //     ]
        //         .filter(exists)
        //         .map((date) => ({
        //             name: "Spring Break 2026 VSB",
        //             date: date,
        //             selected: true,
        //         }));
        // }
        function dateOfYearFunction(mmdd) {
            return function (year) {
                return DateTime.fromISO(`${year}-${mmdd}`);
            };
        }
        function superBowl(year) {
            return nthWeekdayOfMonth(year, 2, 2, 7); // 2nd Sunday of February
        }
        function familyDay(year) {
            return nthWeekdayOfMonth(year, 2, 3, 1); // 3rd Monday of February
        }
        function victoriaDay(year) {
            // last Monday before May 25 (second last Monday of May)
            let date = DateTime.fromISO(`${year}-05-25`).startOf("week");
            return date.dayOfWeek == 1 ? date : date.minus({ days: 7 });
        }
        function thanksgiving(year) {
            return nthWeekdayOfMonth(year, 10, 2, 1); // 2nd Monday of October
        }
        function grapesAndHops(year) {
            return nthWeekdayOfMonth(year, 11, 3, 5); // 3rd Friday of November
        }
        function labourDay(year) {
            return nthWeekdayOfMonth(year, 9, 1, 1); // 1st Monday of September
        }
        // return the dayFunction date if in range or null
        // expects 1 year max interval
        function inrangeDate(dayFunction) {
            let date1 = dayFunction(startDate.year),
                date2 = dayFunction(endDate.year);
            return date1 >= startDate && date1 <= endDate
                ? date1
                : date2 >= startDate && date2 <= endDate
                    ? date2
                    : null;
        }
        function nthWeekdayOfMonth(year, month, n, weekday) { // weekday: 1 (Mon) - 7 (Sun)
            let firstDayOfMonth = DateTime.local(year, month, 1);
            const weekdayOfFirstDay = firstDayOfMonth.weekday, // 1 (Mon) - 7 (Sun)
                daysToFirst = (weekday - weekdayOfFirstDay + 7) % 7,
                totalDaysToAdd = daysToFirst + (n - 1) * 7;
            return firstDayOfMonth.plus({ days: totalDaysToAdd });
        }
    }

    /**
     * Truncate public holidays based on user-selected date range.
     * @param {Array} calendarHolidays
     * @param {DateTime} startDate
     * @param {DateTime} endDate
     * @returns An array of truncated holiday objects.
     */
    getHolidays(calendarHolidays, startDate, endDate) {
        let _startDate = DateTime.fromISO(startDate),
            _endDate = DateTime.fromISO(endDate),
            holidays = [...calendarHolidays];

        holidays.push(...this.getNoApiHolidays(_startDate, _endDate));

        return holidays
            .filter((item) => {
                return (
                    item.date.startOf("day") >= _startDate &&
                    item.date <= _endDate.startOf("day")
                );
            })
            .sort((a, b) => {
                return a.date > b.date ? 1 : -1;
            });
    }

    /**
     * Apply holidays
     * @param {*} holidays
     * @param {*} gameDateTimes
     */
    applyHolidays(holidays, gameDates) {
        let selectedHolidays = holidays
            .filter((holiday) => holiday.selected)
            .map((holiday) => holiday.date.toFormat("yyyy-MM-dd"));

        for (let gameDate of gameDates) {
            gameDate.holiday =
                selectedHolidays.indexOf(
                    gameDate.date.toFormat("yyyy-MM-dd")
                ) != -1;
        }

        return gameDates;
    }
}

let holidayService = new HolidayService();

export default holidayService;
